/**
 * Tablas de puntuacion del sistema.
 * Espejo del seed en 0004_realtime.sql -- mismos UUID a proposito, para
 * que el cliente pueda rankear offline sin haberlas descargado.
 */
export const SCORING_TABLE_IDS = {
    CROSSFIT_GAMES: '00000000-0000-0000-0000-00000000c401',
    GOLF: '00000000-0000-0000-0000-00000000c402',
};
/**
 * Tabla estandar de 100 puntos.
 *
 *   1.o a 6.o   baja de 5 en 5:  100, 95, 90, 85, 80, 75
 *   7.o a 30.o  baja de 2 en 2:  73, 71, 69 ... 27
 *
 * Espejo del seed corregido en 0012_scoring_table_fix.sql. Los valores no
 * son decorativos: un atleta que conoce el estandar detecta al instante si
 * no cuadran, y deja de fiarse del resto de la clasificacion.
 */
const CROSSFIT_GAMES_POINTS = [
    ...Array.from({ length: 6 }, (_, i) => 100 - i * 5),
    ...Array.from({ length: 24 }, (_, i) => 73 - i * 2),
];
function toRows(points) {
    const rows = {};
    points.forEach((value, index) => {
        rows[index + 1] = value;
    });
    return rows;
}
/** Tabla estandar de 100 puntos usada en la mayoria de competencias. */
export const CROSSFIT_GAMES_TABLE = {
    id: SCORING_TABLE_IDS.CROSSFIT_GAMES,
    name: 'Índice de puntos (100 por WOD)',
    kind: 'points_desc',
    defaultPoints: 0,
    rows: toRows(CROSSFIT_GAMES_POINTS),
};
/** Menor total gana: la posicion es el puntaje. */
export const GOLF_TABLE = {
    id: SCORING_TABLE_IDS.GOLF,
    name: 'Puntos por posición (menor total gana)',
    kind: 'golf',
    defaultPoints: 0,
    rows: {},
};
export const SYSTEM_SCORING_TABLES = [CROSSFIT_GAMES_TABLE, GOLF_TABLE];
//# sourceMappingURL=scoring-tables.js.map